// src/pages/config.js
// Resolve the correct base URL for API calls based on the current hostname.
// Examples:
//   stasney.ogfieldticket.ogpumper.net → https://stasney.ogfieldticket.ogpumper.net
//   testtwo.ogfieldticket.ogpumper.net → https://testtwo.ogfieldticket.ogpumper.net
//   anything else → fallback to https://testtwo.ogfieldticket.ogpumper.net

const getBaseUrl = () => {
  const hostname = window.location.hostname || "";
  const parts = hostname.split(".");

  // Handle standard tenant subdomain pattern: <tenant>.ogfieldticket.ogpumper.net
  if (parts.length > 2 && parts[1] === "ogfieldticket" && parts[2] === "ogpumper") {
    return `https://${parts[0]}.ogfieldticket.ogpumper.net`;
  }

  // Local dev: use current origin to simplify testing (optional, but handy)


  // Fallback tenant
  return "https://testtwo.ogfieldticket.ogpumper.net";
};

export const baseUrl = getBaseUrl();

// API version tag (useful if you roll versioned endpoints later)
export const API_VERSION = "v1";
